import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../Errors/InvalidParamsSharedError.js'

const EMPTY_STRING = ''

export class ImageSharedValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static empty() {
    return new ImageSharedValueObject({value: EMPTY_STRING})
  }

  static validate({value}) {
    if (typeof value !== 'string') {
      throw InvalidParamsSharedError.create(`[ImageSharedValueObject.validate] param(${value}) should be a string`)
    }
  }

  static create({value}) {
    return new ImageSharedValueObject({value})
  }

  get value() {
    return this.#value
  }

  isEmpty() {
    return this.#value === EMPTY_STRING
  }

  // Legacy method, please use toPrimitives instead
  toJSON() {
    return {value: this.#value}
  }

  toPrimitives() {
    return {value: this.#value}
  }
}
